import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { v4 as uuidv4 } from 'uuid';
import { insuranceData } from './data';

export const VALID_PROVINCES = {
  AB: 'Alberta',
  BC: 'British Columbia',
  MB: 'Manitoba',
  NB: 'New Brunswick',
  NL: 'Newfoundland and Labrador',
  NS: 'Nova Scotia',
  NT: 'Northwest Territories',
  NU: 'Nunavut',
  ON: 'Ontario',
  PE: 'Prince Edward Island',
  QC: 'Quebec',
  SK: 'Saskatchewan',
  YT: 'Yukon'
};

export function validateProvinceCode(code: string | null): string | null {
  if (!code) return null;
  const upperCode = code.toUpperCase();
  return Object.keys(VALID_PROVINCES).includes(upperCode) ? upperCode : null;
}

export function hasConsecutiveDigits(str: string) {
  const digits = str.replace(/\D/g, '');
  for (let i = 0; i < digits.length - 4; i++) {
    const digit = digits[i];
    if (digits.slice(i, i + 5) === digit.repeat(5)) {
      return true;
    }
  }
  return false;
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getSubmissionId(): string {
  const storageKey = 'submission_id';
  let userId;
  
  try {
    userId = localStorage.getItem(storageKey);
  
    if (!userId) {
      userId = uuidv4();
      localStorage.setItem(storageKey, userId);
    }
  } catch (error) {
    // Generate a new ID if localStorage is not available
    userId = uuidv4();
  }
  
  return userId;
}

export function getQuoteData(age: string, gender: string, coverage: string) {
  const key = `${age}-NS-${gender.charAt(0)}-${coverage.slice(0, -3)}K`;
  const row = insuranceData.find((row) => row.ID === key);
  
  if (!row) return null;
  
  return {
    quotes: {
      emma: row.Emma || null,
      empire: row.Empire || null,
      cpp: row.CPP || null,
      uv: row.UV || null,
      assumption: row.Assumption || null,
      humania: row.Humania || null,
    },
    metadata: {
      id: row.ID,
      smoker_status: row['Smoker Status']
    }
  };
}